<style lang="less">
.account_codepay{

}
</style>

<template>
	<!-- Main account_codepay -->
	<section class="account_codepay">
		<div class="form">
			<div class="item">
				<div class="label">预留手机号</div>
				<div class="cont">
					<input type="text" maxlength="11" value="" placeholder="请输入预留手机号" v-model="info.phone" class="disable" disabled="disabled" />
				</div>
			</div>
			<smscode v-on:send="prepay" v-on:smscode="setSmsCode" :start="timestart"></smscode>
			<div class="tips" v-show="tips">{{tips}}</div>
		</div>

		<footbtn btn-txt="下一步" :is-on="isActive" @click.native="next"></footbtn>
	</section>
</template>

<script>
	/*
		global Finish
		global track
	*/
	import android from '@flyme/jr/js/android.js';
	import footbtn from '@flyme/jr/flyme7/component/foot-btn-simple/foot-btn-simple.vue';

	import axios from '../axios.js';
	import apis from '../apis.js';
	import config from '../config.js';

	import smscode from '../components/smscode.vue';

	export default {
		data: function () {
			return {
				timestart: '0',
				tips: '',
				info: {
					phone: '',
					verify_code: ''
				},
				payData: {
					order_id: '',
					vld_type: '',
					vld_token: '',
					vld_data: '',
					sys_reserved_info: '',
					app_info: ''
				}
			};
		},
		computed: {
			isActive: function() {
				return this.payData.vld_data ? true : false;
			}
		},
		components: {
			smscode,
			footbtn
		},
		mounted: function () {
			// this.prepay();
			this.timestart = 'send';
		},
		methods: {
			prepay: function () {
				let orderInfo = JSON.parse(this.$route.query.data);
				let _this = this;

				android('showLoadingDialog', {
					mes: '正在加载'
				});

				axios.post(apis.acct_order_prepay, {
					order_id: orderInfo.order_id,
					vld_type: 1,
					app_info: this.$route.query.app_info
				}).then(function(d) {
					console.log('acct_order_prepay', d);
					android('hideLoadingDialog');
					if (d.code != 200) {
						_this.tips = d.message;
					}else{
						_this.info.phone = d.value.v_code_req.phone;
						_this.payData.order_id = orderInfo.order_id;
						_this.payData.vld_type = 1;
						_this.payData.vld_token = d.value.token;
						_this.payData.vld_data = '';
						_this.payData.sys_reserved_info = _this.$route.query.sys_reserved_info;
						_this.payData.app_info = _this.$route.query.app_info;
					}
				});
			},
			setSmsCode: function (code) {
				this.payData.vld_data = code;
			},
			getBankInfo: function () {
				let _this = this;
				axios.post(apis.bank_query, {
					bacc_no: this.info.bacc_no,
					type: 1,
					partner_id: config.partner_id,
					partner_cp_type: config.partner_cp_type,
					client_payment_types: ''
				}).then(function(d) {
					console.log('bank_query', d);
					if (d.code != 200) {
						_this.tips = d.message;
					}else{
						_this.info.acc_type = d.value.cardType;
						_this.info.bank_code = d.value.bankCode;
						_this.info.bank_name = d.value.bankName;
						_this.sendsms();
					}
				});
			},
			next: function () {
				let _this = this;
				if (!this.payData.vld_data) {
					return;
				}
				android('showLoadingDialog', {
					mes: '正在加载'
				});
				axios.post(apis.acct_order_pay, this.payData).then(function(d) {
					console.log('acct_order_pay', d);
					android('hideLoadingDialog');
					if (d.code != 200) {
						track('event_acct_order_pay', {
							way: 'code',
							result: 'faild'
						});
						_this.tips = d.message;
					}else{
						if (d.value.resp_code == 23005) {
							window.G_charge_desc = _this.charge_desc;
							window.G_charge_cancle = _this.charge_update_cancle;
							android('showDialog', {
								title: '',
								message: d.value.pay_status_remark,
								okText: '升级',
								cancelText: '暂不',
								okCallBack: 'G_charge_desc',
								cancelCallback: 'G_charge_cancle',
								dismissCallback: ''
							});
							track('event_acct_order_pay', {
								way: 'code',
								result: 'faild'
							});
						} else {
							track('event_acct_order_pay', {
								way: 'code',
								result: 'success'
							});
							_this.$router.replace({path: '/account/result', query: {pay_order_id: d.value.pay_order_id, isCodePay: true} });
						}
					}
				});
			},
			charge_desc: function () {
				this.$router.replace({ path: '/verify' });
			},
			charge_update_cancle: function () {
				Finish('Account_codepay');
			}
		}
	};
</script>


// WEBPACK FOOTER //
// src/pages/Account_codepay.vue